"use client"

import type { BannerData } from "./banner.data";

import Link from "next/link";
import ChevronRightIcon from "../icons/ChevronRightIcon";

export default function Banner({ banner }: { banner: BannerData }) {

  if (!banner) return null

  return (
    <Link
      href={banner.url ?? "/"}
      onClick={(e) => {
        if (banner.url?.includes("?")) {
          e.preventDefault()
          const url = banner.url
          if (url.startsWith("https://") || url.startsWith("http://") || url.startsWith("/")) {
            window.location.href = url
          }
        }
      }}
      className="bg-[#FD8C66] fixed top-0 inset-x-0 w-screen z-999 px-4 flex justify-center items-center hover:gap-2 gap-0.5 transition-all ease-in-out h-10 overflow-x-hidden"
    >
      <p className="text-white font-medium tracking-normal text-base line-clamp-1 relative z-10">{banner.announcement}</p>
      <div className="shrink-0 relative z-10">
        <ChevronRightIcon />
      </div>
      {/* Gradient bubbles */}
      <div className="absolute pointer-events-none inset-0 overflow-hidden rounded right-0">
        <div className="animate-random-bubble gradient-bubble-xl absolute" />
        <div className="animate-random-bubble gradient-bubble-xl absolute right-0" />
      </div>
    </Link>
  )
}